import {toISODate, toInt} from "../../../../utils/convert-fields"
import {formatDateBr} from "../../../../utils/convert-fields"

export const recompraProgramadaFields = [
    {"key": "IDRecompraProgramada", "label": "ID Recompra Programada"},
    {"key": "DataReferencia", "label": "Data Referência"},
    {"key": "DataRecompraProgramada", "label": "Data Recompra Programada"},
]

export const mapRecompraProgramadaProjetarPayload = (
    IDEmissao,
    CETIP,
    VersaoDocumento,
    RendaFixaCaracteristicasID,
    Perpetuidade,
    parametrosPayload,
) => ({
    IDEmissao,
    CETIP,
    VersaoDocumento,
    RendaFixaCaracteristicasID,
    Perpetuidade,
    DataReferencia: parametrosPayload.DataReferencia ?? null,
    DataCarenciaRecompra: parametrosPayload.DataCarenciaRecompra ?? null,
    FrequenciaRecompra: parametrosPayload.FrequenciaRecompra ?? null,
    DataVencimento: parametrosPayload.DataVencimento ?? null,
    TipoAtivo: parametrosPayload.TipoAtivo ?? null,
})

export const mapRecompraProgramadaPayload = (
    tableData = [],
    idCaracteristica
) => {
    const recompras = tableData
        .filter(column =>
            column &&
            Object.keys(column).length > 0 &&
            Object.values(column).some(v => v !== "" && v !== null && v !== undefined)
        )
        .map((column) => ({
            RendaFixaCaracteristicasID: idCaracteristica,
            IDRecompraProgramada: toInt(column.IDRecompraProgramada),
            DataReferencia: toISODate(column.DataReferencia),
            DataRecompraProgramada: toISODate(column.DataRecompraProgramada),
        }))

    return {
        RecomprasProgramadas: recompras,
    }
}

export const mapRecompraProgramadaToTable = (apiData = []) => {
    if (!apiData || apiData.length === 0) return [{}]

    return apiData.map(item => ({
        ID: item.ID,
        IDRecompraProgramada: item.IDRecompraProgramada ?? null,
        DataReferencia: item.DataReferencia ? formatDateBr(item.DataReferencia) : "",
        DataRecompraProgramada: item.DataRecompraProgramada ? formatDateBr(item.DataRecompraProgramada) : "",
    }))
}